import type { FlowNodeResultADT } from '@lighthouse/shared'
import { t } from 'i18next'

export const updatePageShare = async (): Promise<undefined | FlowNodeResultADT> => {
    throw new Error(t('cannotUpdatePageShare'))
}
